import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'

const OrderPendingReviewAlert = () => {
  const { t } = useTranslation(['Clients'])

  return (
    <KibTopLevelAlert
      heading={t(
        'Clients:TIMELINE.PRESCRIPTION_CARD.ALERT_ORDER_PENDING_REVIEW',
      )}
      severity="information"
    />
  )
}

export default OrderPendingReviewAlert
